import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'loanpurpose'
})
export class LoanpurposePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value == "0") {
      return "Micro Lender";
    } 
    if (value == "1") {
      return "Micro Lender";
    } 
    if (value == "2") {
      return "Micro Lender";
    } 
    if (value == "3") {
      return "Micro Lender";
    } 
    if (value == "4") {
      return "Micro Lender";
    } 
    if (value == "5") {
      return "Micro Lender";
    } 
    if (value == "6") {
      return "Micro Lender";
    } 
    if (value == "7") {
      return "Micro Lender";
    } 
    if (value == "8") {
      return "Micro Lender";
    } 
  }

}
